module.exports = __webpack_public_path__ + "static/media/pla_vib_con_ser.36fb06b3.png";